import "jquery/dist/jquery.min.js";
  import Endpoints from "@/config/ApiEndpoints.js";
  import Axios from "axios";
  import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
  import {
    CalendarView,
    CalendarViewHeader,
    CalendarMathMixin    
  } from "vue-simple-calendar";
  import Datepicker from "vuejs-datepicker";
  import { replace } from "feather-icons";
  import VehicleRegistrationRegion from "@/assets/js/vehicle_registration_region.js";
import { setTimeout } from "core-js";
  var moment = require("moment");

  export default {
    props: ["AssetDetails"],
    components: {
      CalendarView,
      CalendarViewHeader,
      Datepicker
    },
    filters: {
      date: function (data) {
        var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY");
        }
        return sendDate;
      },
      region: function(data){
        return VehicleRegistrationRegion(data);
      }
    },
    data() {
      return {
        format: "dd-MM-yyyy",
        VehicleImageEndpoint: Endpoints.Vehicle.Image + "/",
        PopupLoader: false,
        ShowLoader: false,
        AdditionalFilesSaving: false,
        submitted: false,
        editForm:false,
        editCheckSettingForm:false,
        editAssignmentForm:false,
        editServiceForm:false,
        SaveData:false,
        SaveAssignmentData:false,
        SaveCheckSettingsData:false,
        SaveServiceData:false,
        SavingFile:false,
        Saving:false,
        ExemptPsv:true,
        ShowBranches:false,
        AssetId: 0,
        componentKey:0,
        Branches:{},
        AdditionalImages:[],
        AssetCheckSettings: [],
        EditAsset: {
          branch_id:0,
          name: "",
          type: "",
          responsibility: "",
          description: "",
          serial_number: "",
          make: "",
          model: "",
          year: "",
          training_type: "",
          visibility: 1,
          photo: "",
          additional_photos: "",
          category:"",
          sub_category: "",
          group: "",
          ownership: "",
          location: "",
          assignments: [],
          asset_check_settings: [],
          requires_servicing: "",
          service_interval_hours: "",
          service_interval_miles: "",
          service_interval_months: "",
          last_service_hours: "",
          last_service_miles: "",
          last_service_date: "",
          current_hours: "",
          current_miles: "",
          next_service_hours: "",
          next_service_miles: "",
          next_service_date: "",
          next_service_hours_before: "",
          next_service_miles_before: "",
          next_service_date_before: "",
          service_measurement: "",
        },
        DriverList: [],
        VehicleList: [],
        CategoryList: [],
        SubCategoryList: [],
        GroupList: [],
        LocationList: [],
        OwnershipList: [],
        select_branch:true,
        FleetSubscriptionModules:[],
        ShowKM:false,
      };
    },
    validations: {
      EditAsset: {
        name: { required },
        type: { required },
        responsibility: { required },
        //description: { required },
        service_measurement: { required },
        serial_number: { required },
        make: { required },
        model: { required },
        year: { required },
      }
    },
    mounted() {
      var CompanyData = JSON.parse(localStorage.getItem("Company"));
      if (CompanyData.mileage_unit == 2) {
        this.ShowKM = true;
      }
      this.AssetId = this.$route.params.AssetId;
      setTimeout(() => {
        this.EditAsset = this.AssetDetails;
        if(this.EditAsset.asset_check_settings != null){
          this.EditAsset.asset_check_settings = JSON.parse(this.EditAsset.asset_check_settings);
          this.AssetCheckSettings = this.EditAsset.asset_check_settings;
        }  
        if(this.EditAsset.assignments.length==0){
          this.initAssignments();
        }   
        if(this.EditAsset.additional_photos != null && this.EditAsset.additional_photos != "" && this.EditAsset.additional_photos.length > 0){
          this.AdditionalImages = this.EditAsset.additional_photos;
        }   
      }, 500); 

      this.AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
        );
      this.FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
  
      var FleetSubscriptionModules = JSON.parse(
        this.FleetSubscription.fleet_modules
      );
      
      //check account permission
      if (FleetSubscriptionModules && 
      FleetSubscriptionModules.Branches) {
        this.ShowBranches = true;
      }

      this.GetDriverList();
      this.GetVehicleList();
      this.GetCategoryList();
      this.GetGroupList();
      this.GetLocationList();
      this.GetOwnershipList();
      this.GetBranches();
    },
    computed : {
      
      years () {
        const year = new Date().getFullYear()
        return Array.from({length: year - 1969}, (value, index) => 1970 + index)
      }
    },
    methods: {
      checkMeasurement(){
        var service_measurement = this.EditAsset.service_measurement;
        this.AssetCheckSettings.splice(this.AssetCheckSettings.indexOf('Record Current Miles'));
        this.AssetCheckSettings.splice(this.AssetCheckSettings.indexOf('Record Current Hours'));
        this.AssetCheckSettings.push('Confirm Safe Working Order');
        if(service_measurement == "Miles"){
          this.AssetCheckSettings.push('Record Current Miles');
        }
        if(service_measurement == "Hours"){
          this.AssetCheckSettings.push('Record Current Hours');
        }
      },
      GetBranches(){
        var obj = { token: localStorage.getItem("token"), select_branch:true };
        Axios.post(Endpoints.Branch.List, obj).then((Response) => {
          if (Response.data.success) {
            this.Branches = Response.data.records;
            if(this.FleetSubscriptionModules["Hierarchy System"] && this.Branches.length == 1){
              this.EditAsset.branch_id = this.Branches[0].id;
              this.select_branch = false;
            }

          }
        });
      },
      UpdateAsset(type) {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        if(type == 'Asset Service Details'){
          this.SaveServiceData = true;
        }else if(type == 'Asset Assignment Details'){
          this.SaveAssignmentData = true;
        }else if(type == 'Asset Check Setting'){
          this.SaveCheckSettingsData = true;
        }else{
          this.SaveData = true;
        }
    
        this.Saving = true;
        this.EditAsset.asset_check_settings = this.AssetCheckSettings;
        
        Axios.post(Endpoints.Assets.Update, {
          token: localStorage.getItem("token"),
          SubmitAssets: this.EditAsset,
        }).then((Response) => {
          this.Saving = false;
          if (Response.data.success) {
            this.$emit("classUpdate");
            this.$swal
              .fire(type+" has been Updated Successfully", "", "success")
              .then(() => {
                  this.file = '';
                  this.CancelEditAssetPage();
                  this.CancelEditAssetAssignmentPage();
                  this.CancelEditAssetServicePage();
                  this.CancelEditAssetServicePage();
                  this.CancelEditCheckSettingsPage();
              });
          } else {
            this.$swal.fire({
              title: "Oops!",
              text: Response.data.message,
              icon: "error",
              confirmButtonText: "Close",
            });
          }
        });
      },
      initAssignments() {
        var obj = {
          id:0,	
          driver_id: "",
          vehicle_id: "",
          department: "",
          location_id: "",
          assigned_date: "",
          last_location_id: "",
          last_known_date: "",
        };

        this.EditAsset.assignments.push(obj);
      },
      deleteAssignments(assignmentsIndex,assignments) {
        this.EditAsset.assignments.splice(assignmentsIndex, 1);
        if(assignments.id > 0 ){
        	Axios.post(Endpoints.Assets.Assignments.Delete, {
          		token: localStorage.getItem("token"),
          		id: assignments.id,
        	}).then((Response) => {
        		this.$swal.fire('Assets Assignment Deleted Successfully', '', 'success').then(() => {});
        	});
        }
      },
      GetDriverList() {
        Axios.post(Endpoints.Driver.List, {
          token: localStorage.getItem("token"),
        }).then((Response) => {
          if (Response.data.success) {
            this.DriverList = Response.data.drivers;
          }
        });
      },
      GetVehicleList() {
        Axios.post(Endpoints.Vehicle.ListPlain, {
          token: localStorage.getItem("token"),
        }).then((Response) => {
          if (Response.data.success) {
            this.VehicleList = Response.data.vehicles;
          }
        });
      },
      GetCategoryList() {
        Axios.post(Endpoints.Assets.Category.List, {
          token: localStorage.getItem("token"),
        }).then((Response) => {
          if (Response.data.success) {
            this.CategoryList = Response.data.CategoryList;
            setTimeout(() => {
              this.SetSubCategories();
            }, 500);
          }
        });
      },
      GetGroupList() {
        Axios.post(Endpoints.Assets.Group.List, {
          token: localStorage.getItem("token"),
        }).then((Response) => {
          if (Response.data.success) {
            this.GroupList = Response.data.GroupList;
          }
        });
      },
      GetLocationList() {
        Axios.post(Endpoints.Assets.Location.List, {
          token: localStorage.getItem("token"),
        }).then((Response) => {
          if (Response.data.success) {
            this.LocationList = Response.data.LocationList;
          }
        });
      },
      GetOwnershipList() {
        Axios.post(Endpoints.Assets.Ownership.List, {
          token: localStorage.getItem("token"),
        }).then((Response) => {
          if (Response.data.success) {
            this.OwnershipList = Response.data.OwnershipList;
          }
        });
      },
      SetSubCategories(){
         this.SubCategoryList = [];
          var CategoryID = this.EditAsset.category;
          if(CategoryID > 0){
            this.CategoryList.forEach((element) => {
              if (element.id === CategoryID && element.sub_categories && element.sub_categories.length > 0) {
                this.SubCategoryList = element.sub_categories;
              }
            });
          }
      },
      handleFileUpload() {
        this.file = this.$refs.file.files[0];
      },
      UpdateAssetData(type) {
        this.Saving = true;
        if (this.$refs.file && this.$refs.file.files[0]) {
        let formData = new FormData();
        formData.append('token', localStorage.getItem('token'));
        formData.append('storage_type', 'CFAST');
        formData.append('file', this.file);
        Axios.post(Endpoints.File.Upload, formData).then((Response) => {
          this.Saving = false;
          if (Response.data.success == true) {
              this.EditAsset.photo = Response.data.file;
              this.UploadAdditionalFile(type);
          } else {
            this.$swal.fire('Error in File Uploading', '', 'error').then(() => {});
          }
        });
      }else{
        this.UploadAdditionalFile(type);
      }
      },
      UploadAdditionalFile(type) {
        if (this.$refs.additional_files && this.$refs.additional_files.files[0]) {
        const files = this.$refs.additional_files.files;
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          // Validate if file is an image
          if (!file.type.match('image.*')) {
            continue;
          }
          this.AdditionalFilesSaving = true;
          let formData = new FormData();
          formData.append('token', localStorage.getItem('token'));
          formData.append('storage_type', 'CFAST');
          formData.append('file', file);
          Axios.post(Endpoints.File.Upload, formData).then((Response) => {
            if (Response.data.success == true) {
              this.AdditionalFilesSaving = false;
              var FileName = Response.data.file
                this.AdditionalImages.push(FileName);
                if(files.length == (i+1)){
                  this.EditAsset.additional_photos = this.AdditionalImages;
                  this.UpdateAsset(type);
                }
            } else {
              this.$swal.fire('Error in File Uploading', '', 'error').then(() => {});
            }
          });
        }
      }else{
        this.UpdateAsset(type);
      }
      },
      EditAssetPage() {
        this.editForm = true;
      },
      EditAssetAssignment() {
        this.editAssignmentForm = true;
      },
      EditCheckSetting() {
        this.editCheckSettingForm = true;
      },
      EditAssetServicePage() {
        this.editServiceForm = true;
      },
      CancelEditCheckSettingsPage() {
        this.SaveCheckSettingsData = false;
        this.editCheckSettingForm = false;
      },
      CancelEditAssetPage() {
        this.SaveData = false;
        this.editForm = false;
      },
      CancelEditAssetAssignmentPage() {
        this.SaveAssignmentData = false;
        this.editAssignmentForm = false;
      },
      CancelEditAssetServicePage() {
        this.SaveServiceData = false;
        this.editServiceForm = false;
      },
      ShowLocationMaps(Details){
        this.$root.$emit('ShowLocationMaps', Details);
      },
      GetNextServiceHours(){
      	if(+this.EditAsset.last_service_hours > 0 && +this.EditAsset.service_interval_hours > 0){
      		this.EditAsset.next_service_hours = +this.EditAsset.last_service_hours + +this.EditAsset.service_interval_hours
      	}
      },
      GetNextServiceMiles(){
      	if(+this.EditAsset.last_service_miles > 0 && +this.EditAsset.service_interval_miles > 0){
      		this.EditAsset.next_service_miles = +this.EditAsset.last_service_miles + +this.EditAsset.service_interval_miles
      	}
      },
      GetNextServiceDate(){      	
      	if(this.EditAsset.last_service_date !="" && +this.EditAsset.service_interval_months > 0){
      		var newDate = moment(this.EditAsset.last_service_date).add(+this.EditAsset.service_interval_months, 'M').format('YYYY-MM-DD');       		      		
      		this.EditAsset.next_service_date = newDate
      	}
      }
    },
  };